import Btn from './Button';
import decodeUriComponent from 'decode-uri-component';
import ReactModal  from 'react-modal';
import External from './Extrenal';
import { useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
const PicOfTheDay = (props) => {
     const [isOpen, setPopupIsOpen] = useState(false);    
     const [screenWidth, setScreenWidth] = useState(window.innerWidth);   
    const { t } = useTranslation();
     const toggleOpen = () => {
        
        setPopupIsOpen(!isOpen);
      }
    const morePics = () => {
        
        toggleOpen();
    };

    useEffect(() => {
              const handleResize = () => {
                  setScreenWidth(window.innerWidth);
                  //alert(window.innerWidth);
      
              };
              
              handleResize();
              window.addEventListener('resize', handleResize);
      
              // Clean up the event listener when the component unmounts
              return () => {
                  window.removeEventListener('resize', handleResize);
              };
              
              }, []); // Empty dependency array means this effect runs once on mount
    
      const customStyles = {
        content: {
          width:(screenWidth > 1200 ) ? screenWidth*0.8 +'px' :'100%',
          padding: '5px',
          top: '0',
          left: '0',
          direction: (props.lang == 1) ? 'rtl' : '',
          right: 'auto',
          bottom: '0',
          position: 'absolute',
          marginRight: '',
          transform: '',
        },
      };
    let caption = eval(`props.pic.caption${props.lang}`);
    let latespic = decodeUriComponent(caption).replace(/\+/g, ' ');
    let pic_url = `thumb.php?src=${props.pic.picurl}&sx=1650&sy=1250&w=452&h=450`;
    return (
        <div className="pic_of_the_day white_transp_box white_box d-grid align-items-center justify-items-center justify-content-center">
        <h4>{t('PIC_OF_THE_DAY')}</h4>
        <img src={`https://v2013.02ws.co.il/${pic_url}`} height="230" alt="" className="rounded align-self-center"></img> 
        <div className={" " + ((props.lang == 1) ? 'text-right' : '') + "  "} >{latespic}</div>
        
        <Btn btnOnClick={() => morePics()} btnTitleText={t('MORE_PIC_OF_THE_DAY')} img={(props.lang == 1)? "ArrowLeft" : "ArrowRight"} />
         <ReactModal
            
            isOpen={isOpen}
            contentLabel="Example Modal"
            style={customStyles}
            onRequestClose={() => toggleOpen(false)}

        >
            <Btn btnOnClick={() => toggleOpen(false)} btnTitleText={""}  img={"X"} cssClasses={(props.lang == 1? 'float-start' : 'float-end')}>
                    
            </Btn>
            <div className="sidepopup">
            <External src={"https://v2013.02ws.co.il/small/?section=picoftheday.php&lang=" + props.lang} width="100%" height="95%" className={props.cssClasses}/>
            </div>
        </ReactModal>
        </div>
        
    );
}

export default PicOfTheDay; 